import {
    useMutation,
    UseMutationResult,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import simpleApi from 'app/services/simpleApi'
import {
    RequestConfig,
} from 'app/types/request.types'

export default function useSimpleApiRequest<RequestParams = Record<string, any>>({
    onSuccess,
    onError,
    name,
    requestParams,
    title,
}: {
    onSuccess: (resp) => void,
    onError?: (err) => void,
    name: string,
    requestParams: { url: string, method: string } | RequestConfig,
    title?: string,
}): UseMutationResult<unknown, unknown, RequestParams> {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessHandler,
        onError: onErrorHandler,
    } = useHandleStatusRequest({
        id: name,
        title,
        onSuccess,
        onError,
    })

    return useMutation<undefined, undefined, RequestParams>({
        mutationFn: (data) => {
            return simpleApi({
                ...requestParams,
                data,
                token,
            })
        },
        onSuccess: onSuccessHandler,
        onError: onErrorHandler,
    })
}
